import { render, staticRenderFns } from "./AddPrizeModal.vue?vue&type=template&id=a53dc082"
import script from "./AddPrizeModal.vue?vue&type=script&lang=js"
export * from "./AddPrizeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports